import React, { useEffect, useState } from 'react';
import AdminHeading from '../AdminPanel/Heading/AdminHeading';
import AdminBreadCrump from '../AdminPanel/Heading/AdminBreadCrump';
import '../PagesStyles/AdminMasters.css';
import { allCountriesList } from '../../Api/CountriesAllList';
import { allStateList } from '../../Api/StateList';
import { a128 } from 'Components/Api/RootApiPath1';
import { TbCircleNumber1 } from 'react-icons/tb';
import {
  a18,
  a35,
  a7,
  a711,
  a712,
  a713,
  a95,
  a96,
  a97,
} from '../../Api/RootApiPath';
import { useSelector } from 'react-redux';
import { RiListUnordered, RiPlayListAddLine } from 'react-icons/ri';
import AlertMessage from '../../Other Functions/AlertMessage';
import style from './AddCompanyNew.module.css';
import { Icon } from '@iconify/react';
import Box from '@mui/material/Box';
import Customertable from 'Components/support/customervendor/customer';
import { useRef } from 'react';
import { Toaster, toast } from 'react-hot-toast';

export default function AddCompanyNew() {
  const [active, setActive] = useState('AddNew');
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState('');
  const [messageToShow, setMessageToShow] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState('');

  const [countryStates, setCountryStates] = useState([]);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const states = {
    US: ['California', 'Texas', 'Florida', 'New York'],
    IN: allStateList,
  };
  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log('Searching for:', searchTerm);
  };

  const handleList = () => {
    // Custom logic for the List button
    console.log('List button clicked');
    setActive('List');
  };
  const fetchAllProductsList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a128, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllProductsList(data);
      } else {
        // alert("Please Add Product First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllProductsList();
    if (newCategory.PerAddCountry == 'India') {
      setCountryStates(states.IN);
    }
  }, []);

  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    ClientCode: '',
    CompCode: '',
    CompName: '',
    CompShortName: '',
    CompOwnerName: '',
    CompRegisteredAddress: '',
    CompFactoryAddress: '',
    CompMobileNo: '',
    CompPhoneNo: '',
    CompRegistrationNo: '',
    CompYearOfEstablishment: '',
    CompEmail: '',
    CompGSTINNo: '',
    CompPanNo: '',
    CompAddharNo: '',
    CompLogo: '',
    CompWebsite: '',
    CompVATNo: '',
    CompCGSTNo: '',
    CompStatus: '',
    Town: '',
    Country: 'India',
    PerAddCountry: 'India',
    State: '',
    City: '',
    FinancialYear: '',
    BaseCurrency: '',
    TransactionSeries: '',
    CompLoginStatus: '',
    OldEntry: false,
  });

  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;

  const handleNewCsChange = (e) => {
    const { name, value } = e.target;

    if (name === 'Country') {
      let updatedStates = [];
      if (value === 'India') {
        updatedStates = states.IN; // Set states for India
      } else if (value === 'United States') {
        updatedStates = states.US; // Set states for the US
      }
      setCountryStates(updatedStates);
      newCategory((prev) => ({
        ...prev,
        Country: value,
        CurrAddState: '', // Reset state field when the country changes
      }));
    } else if (name === 'CurrAddState') {
      newCategory((prev) => ({
        ...prev,
        CurrAddState: value, // Update the selected state
      }));
      setShowError(true);
    } else {
      newCategory((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a713, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, 'data,');
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive('addNew');
        document
          .getElementById('addCategoryListTitle')
          .classList.add('activeCategoryTitle');
        document
          .getElementById('addCategoryListLogo')
          .classList.add('activeCategoryLogo');
        document.getElementById('addCategoryListTitle').click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  console.log(allCategories);
  const [editingId, setEditingId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const handleEditClick = (id) => {
    setEditingId(id);
    // Find the item with the selected ID and set its data in the state
    const selectedItem = allCategories.find((x) => x.id === id);
    setEditedData(selectedItem);
  };

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      }
      // else {
      //   if (submitButtonRef.current) {
      //     submitButtonRef.current.click(); // Safely trigger click
      //   } else {
      //     console.error("Submit button ref is not available");
      //   }
      // }
    }
  };

  const handleSaveClick = () => {
    handleSubmit();
    // Save the edited data to your state or send it to an API
    console.log('Edited Data:', editedData);
    setEditingId(null); // Exit editing mode
  };
  const handleSubmit = async () => {
    try {
      const response = await fetch(a35, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editedData),
      });
      const data = await response.json();

      console.log(data, 'updated');
      if (data.Message) {
        // alert(data.Message);
        toast.error(data.Message);

        // setShowError(true);
      } else {
        // setMessageType("success");
        toast.success('Updated successfully', {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
      }
      fetchAllCategory();
    } catch (error) {
      console.error(error);
      alert(error);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setEditedData({ ...editedData, [name]: value });
  };

  const handlenew = () => {
    setActive('AddNew');
  };

  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
  };
  console.log(newCategory, 'newCategory');
  console.log(newCategory, 'newCategory');

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    let formData = new FormData();

    formData.append('ClientCode', clientCode);
    formData.append('CompName', newCategory.CompName);
    formData.append('CompShortName', newCategory.CompShortName);
    formData.append('CompOwnerName', newCategory.CompOwnerName);
    formData.append('CompRegisteredAddress', newCategory.CompRegisteredAddress);
    formData.append('CompFactoryAddress', newCategory.CompFactoryAddress);
    formData.append('CompMobileNo', newCategory.CompMobileNo);
    formData.append('CompPhoneNo', newCategory.CompPhoneNo);
    formData.append('CompRegistrationNo', newCategory.CompRegistrationNo);
    formData.append(
      'CompYearOfEstablishment',
      newCategory.CompYearOfEstablishment
    );
    formData.append('CompEmail', newCategory.CompEmail);
    formData.append('CompGSTINNo', newCategory.CompGSTINNo);
    formData.append('CompPanNo', newCategory.CompPanNo);
    formData.append('CompAddharNo', newCategory.CompAddharNo);
    formData.append('CompLogo', newCategory.CompLogo);
    formData.append('CompWebsite', newCategory.CompWebsite);
    formData.append('CompVATNo', newCategory.CompVATNo);
    formData.append('CompCGSTNo', newCategory.CompCGSTNo);
    formData.append('CompStatus', 'Active');
    formData.append('Town', newCategory.Town);
    formData.append('Country', newCategory.Country);
    formData.append('State', newCategory.State);
    formData.append('City', newCategory.City);
    formData.append('FinancialYear', newCategory.FinancialYear);
    formData.append('BaseCurrency', newCategory.BaseCurrency);
    formData.append('TransactionSeries', newCategory.TransactionSeries);
    formData.append('CompLoginStatus', newCategory.CompLoginStatus || 'Active');
    formData.append(
      'CompCode',
      newCategory.OldEntry ? newCategory.CompCode : '0'
    );
    formData.append('Id', newCategory.OldEntry ? newCategory.Id : '0');

    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a711 : a712,
        // a96,
        {
          method: 'POST',
          // headers: {
          //   "Content-Type": "application/json",
          // },
          body: formData,
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive('List');
      setNewCategory({
        ClientCode: '',
        CompCode: '',
        CompName: '',
        CompShortName: '',
        CompOwnerName: '',
        CompRegisteredAddress: '',
        CompFactoryAddress: '',
        CompMobileNo: '',
        CompPhoneNo: '',
        CompRegistrationNo: '',
        CompYearOfEstablishment: '',
        CompEmail: '',
        CompGSTINNo: '',
        CompPanNo: '',
        CompAddharNo: '',
        CompLogo: '',
        CompWebsite: '',
        CompVATNo: '',
        CompCGSTNo: '',
        CompStatus: '',
        Town: '',
        Country: '',
        State: '',
        City: '',
        FinancialYear: '',
        BaseCurrency: '',
        TransactionSeries: '',
        CompLoginStatus: '',
        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.Message);
        // setMessageType("error");
        toast.error(data.Message, {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
        setActive('AddNew');
      } else {
        // setMessageType("success");
        toast.success('Category Added Successfully!', {
          duration: 3000,
          position: 'top-center',
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, 'data');
    console.log(data, 'data');
    console.log(data, 'data');
    setNewCategory({ ...data, OldEntry: true });
    setActive('AddNew');
  };

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);
  const inputRef12 = useRef(null);
  const inputRef13 = useRef(null);
  const inputRef14 = useRef(null);
  const inputRef15 = useRef(null);
  const inputRef16 = useRef(null);
  const inputRef17 = useRef(null);
  const inputRef18 = useRef(null);
  const inputRef19 = useRef(null);
  const inputRef20 = useRef(null);
  const inputRef21 = useRef(null);
  const inputRef22 = useRef(null);
  const inputRef23 = useRef(null);
  const inputRef24 = useRef(null);
  const inputRef25 = useRef(null);
  const inputRef26 = useRef(null);

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
      inputRef15,
      inputRef16,
      inputRef17,
      inputRef18,
      inputRef19,
      inputRef20,
      inputRef21,
      inputRef22,
      inputRef23,
      inputRef24,
      inputRef25,
      inputRef26,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === 'SELECT') {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ''; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const columns = [
    { key: 'serialNumber', label: 'S.No', type: 'read', priority: 2 },
    { key: 'CompName', label: 'Company Name', type: 'read', priority: 1 },

    {
      key: 'CompShortName',
      label: 'Company ShortName',
      type: 'read',
      priority: 3,
    },
    { key: 'Owner', label: 'Owner', type: 'read', priority: 4 },
    {
      key: 'CompMobileNo',
      label: 'Company Contact No',
      type: 'read',
      priority: 5,
    },
    { key: 'CompStatus', label: 'Status', type: 'read', priority: 6 },
  ];

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: '130px' }}>
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={'Add Company'}
          companyName={'Loyalstring'}
          module={'User Masters'}
          page={'Company'}
        />
      </div>

      <div style={{ padding: '16px' }}>
        {active === 'List' ? (
          <>
            <div className={style['white-space']}>
              <div className={style['icon-div']}>
                <div className={style['search-container']}>
                  <input
                    type="text"
                    value={searchInput}
                    onChange={handleSearchChange}
                    placeholder="Search..."
                    className={style['serach-input']}
                  />
                  <button
                    style={{ margin: 0 }}
                    className={style['search-btn']}
                    //  onClick={handleSearchSubmit}
                  >
                    <Icon style={{ fontSize: '20px' }} icon="mdi:magnify" />
                  </button>
                </div>

                <Icon
                  style={{
                    fontSize: '28px ',
                    color: '#0077d4',
                    cursor: 'pointer',
                  }}
                  icon="bx:export"
                />

                <button
                  // style={{ width: "30%" }}
                  className={style['custom-btn']}
                >
                  <Icon style={{ fontSize: '24px ' }} icon="ic:outline-print" />
                  Print
                </button>
                <button
                  onClick={handlenew}
                  style={{ margin: 0 }}
                  className={style['custom-btn']}
                >
                  New
                  <Icon icon="mdi:plus" width="24" height="24" />
                </button>
              </div>
            </div>

            <Customertable
              columns={columns}
              allCategories={allCategories}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}

              // title={"All Customers"}
            />
          </>
        ) : (
          <div className={style.adminAddCategoryMainBox}>
            <div className={style.adminAddCategoryInnerBox}>
              <div className={style.adminCategoryAddCategoryMainBox}>
                <h2
                  style={{ marginTop: '20px', marginBottom: '20px' }}
                  className={style.adminCategoryHeading}
                  id="adminInvoiceAddedCustomerEdit"
                >
                  Add New Company
                </h2>
                {/* <p>Add New Company</p> */}
                <form style={{ width: '100%' }} onSubmit={addNewCategory}>
                  <div
                    style={{
                      gridTemplateColumns: 'repeat(4,2fr)',
                      columnGap: '30px',
                      margin: '0px 0px',
                      padding: 'var(--Space-0, 0px) 24px',
                    }}
                    // className="adminCategoryAddCategoryInnerBox"
                  >
                    {/* <Box sx={{ width: "95%", margin: "0 auto" }}>
                         <div
                            style={{
                                gridTemplateColumns: "repeat(4,1fr)",
                                columnGap: "40px",
                                margin: "15px 0px",
                            }}
                            className="adminCategoryAddCategoryInnerBox"
                            >
                    <label>
                      Company Name <sup>*</sup>
                    </label>
                    <input
                      name="CompName"
                      value={newCategory.CompName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      required
                      style={{border: '1px solid #ddd'}}
                      ref={inputRef1}
                      onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                    />

                    <label>
                      Company Short Name <sup>*</sup>
                    </label>
                    <input
                      name="CompShortName"
                      value={newCategory.CompShortName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                      
                    />

                    <label>Owner Name</label>
                    <input
                      name="CompOwnerName"
                      value={newCategory.CompOwnerName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Registered Address</label>
                    <input
                      name="CompRegisteredAddress"
                      value={newCategory.CompRegisteredAddress}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Factory Address</label>
                    <input
                      name="CompFactoryAddress"
                      value={newCategory.CompFactoryAddress}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>
                      Mobile No <sup>*</sup>
                    </label>
                    <input
                      name="CompMobileNo"
                      value={newCategory.CompMobileNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Phone No</label>
                    <input
                      name="CompPhoneNo"
                      value={newCategory.CompPhoneNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Registration No</label>
                    <input
                      name="CompRegistrationNo"
                      value={newCategory.CompRegistrationNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Year Of Establishment</label>
                    <input
                      name="CompYearOfEstablishment"
                      value={newCategory.CompYearOfEstablishment}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Email</label>
                    <input
                      name="CompEmail"
                      value={newCategory.CompEmail}
                      onChange={handleNewCategoryChange}
                      type="email"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>GSTIN No</label>
                    <input
                      name="CompGSTINNo"
                      value={newCategory.CompGSTINNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Pan No</label>
                    <input
                      name="CompPanNo"
                      value={newCategory.CompPanNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />
                 

                    <label>Company Logo</label>
                    <input
                      name="CompLogo"
                      value={newCategory.CompLogo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Website</label>
                    <input
                      name="CompWebsite"
                      value={newCategory.CompWebsite}
                      onChange={handleNewCategoryChange}
                      type="url"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>VAT No</label>
                    <input
                      name="CompVATNo"
                      value={newCategory.CompVATNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>CGST No</label>
                    <input
                      name="CompCGSTNo"
                      value={newCategory.CompCGSTNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Status</label>
                    <input
                      name="CompStatus"
                      value={newCategory.CompStatus}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>
                      Town <sup>*</sup>
                    </label>
                    <input
                      name="Town"
                      value={newCategory.Town}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>
                      Country <sup>*</sup>
                    </label>
                    <input
                      name="Country"
                      value={newCategory.Country}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>
                      State <sup>*</sup>
                    </label>
                    <input
                      name="State"
                      value={newCategory.State}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>
                      City <sup>*</sup>
                    </label>
                    <input
                      name="City"
                      value={newCategory.City}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>
                      Financial Year <sup>*</sup>
                    </label>
                    <input
                      name="FinancialYear"
                      value={newCategory.FinancialYear}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>
                      Base Currency <sup>*</sup>
                    </label>
                    <input
                      name="BaseCurrency"
                      value={newCategory.BaseCurrency}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>
                      Transaction Series <sup>*</sup>
                    </label>
                    <input
                      name="TransactionSeries"
                      value={newCategory.TransactionSeries}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />

                    <label>Login Status</label>
                    <input
                      name="CompLoginStatus"
                      value={newCategory.CompLoginStatus}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{border: '1px solid #ddd'}}
                    />
                    </div>
                    </Box> */}
                    <Box sx={{ width: '95%', margin: '0 auto' }}>
                      <div
                        style={{
                          gridTemplateColumns: 'repeat(4,1fr)',
                          columnGap: '40px',
                          margin: '15px 0px',
                        }}
                        className="adminCategoryAddCategoryInnerBox"
                      >
                        <label>
                          Company Name <sup>*</sup>
                        </label>
                        <input
                          name="CompName"
                          value={newCategory.CompName}
                          onChange={handleNewCategoryChange}
                          type="text"
                          required
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                        />

                        <label>
                          Company Short Name <sup>*</sup>
                        </label>
                        <input
                          name="CompShortName"
                          value={newCategory.CompShortName}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef2}
                          onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                        />

                        <label>Owner Name</label>
                        <input
                          name="CompOwnerName"
                          value={newCategory.CompOwnerName}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef3}
                          onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                        />

                        <label>Registered Address</label>
                        <input
                          name="CompRegisteredAddress"
                          value={newCategory.CompRegisteredAddress}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef4}
                          onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                        />

                        <label>Factory Address</label>
                        <input
                          name="CompFactoryAddress"
                          value={newCategory.CompFactoryAddress}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef5}
                          onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                        />

                        {/* <label>
                          Mobile No <sup>*</sup>
                        </label>
                        <input
                          name="CompMobileNo"
                          value={newCategory.CompMobileNo}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                        /> */}

                        <label>
                          Mobile No <sup>*</sup>
                        </label>
                        <input
                          name="CompMobileNo"
                          value={newCategory.CompMobileNo}
                          onChange={(e) => {
                            // Allow only numeric values and limit to 10 digits
                            const filteredValue = e.target.value
                              .replace(/[^0-9]/g, '')
                              .slice(0, 10);
                            handleNewCategoryChange({
                              target: {
                                name: 'CompMobileNo',
                                value: filteredValue,
                              },
                            });
                          }}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                        />

                        {/* <label>Phone No</label>
                        <input
                          name="CompPhoneNo"
                          value={newCategory.CompPhoneNo}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef7}
                          onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        /> */}

                        <label>Phone No</label>
                        <input
                          name="CompPhoneNo"
                          value={newCategory.CompPhoneNo}
                          onChange={(e) => {
                            // Allow only numeric values
                            const filteredValue = e.target.value.replace(
                              /[^0-9]/g,
                              ''
                            );
                            handleNewCategoryChange({
                              target: {
                                name: 'CompPhoneNo',
                                value: filteredValue,
                              },
                            });
                          }}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef7}
                          onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                        />

                        <label>Registration No</label>
                        <input
                          name="CompRegistrationNo"
                          value={newCategory.CompRegistrationNo}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef8}
                          onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                        />

                        <label>Year Of Establishment</label>
                        <input
                          name="CompYearOfEstablishment"
                          value={newCategory.CompYearOfEstablishment}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef9}
                          onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                        />

                        <label>Email</label>
                        <input
                          name="CompEmail"
                          value={newCategory.CompEmail}
                          onChange={handleNewCategoryChange}
                          type="email"
                          style={{ border: '1px solid #ddd', width: '100%' }}
                          ref={inputRef10}
                          onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                        />

                        {/* <label>GSTIN No</label>
                        <input
                          name="CompGSTINNo"
                          value={newCategory.CompGSTINNo}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef11}
                          onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                        /> */}

                        <label>GSTIN No</label>
                        <input
                          name="CompGSTINNo"
                          value={newCategory.CompGSTINNo}
                          onChange={(e) => {
                            // Allow only uppercase alphabets and numbers, limit to 15 characters
                            const filteredValue = e.target.value
                              .toUpperCase() // Convert to uppercase
                              .replace(/[^A-Z0-9]/g, '') // Allow only alphabets and numbers
                              .slice(0, 15); // Limit to 15 characters
                            handleNewCategoryChange({
                              target: {
                                name: 'CompGSTINNo',
                                value: filteredValue,
                              },
                            });
                          }}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef11}
                          onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                        />

                        {/* <label>Pan No</label>
                        <input
                          name="CompPanNo"
                          value={newCategory.CompPanNo}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef12}
                          onKeyDown={(e) => handleKeyPress(e, inputRef13)}
                        /> */}

                        <label>Pan No</label>
                        <input
                          name="CompPanNo"
                          value={newCategory.CompPanNo}
                          onChange={(e) => {
                            // Allow only uppercase alphabets and numbers, limit to 10 characters
                            const filteredValue = e.target.value
                              .toUpperCase() // Convert to uppercase
                              .replace(/[^A-Z0-9]/g, '') // Remove non-alphanumeric characters
                              .slice(0, 10); // Limit to 10 characters
                            handleNewCategoryChange({
                              target: {
                                name: 'CompPanNo',
                                value: filteredValue,
                              },
                            });
                          }}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef12}
                          onKeyDown={(e) => handleKeyPress(e, inputRef13)}
                        />

                        <label>Aadhar No</label>
                        <input
                          name="CompAddharNo"
                          value={newCategory.CompAddharNo}
                          onChange={(e) => {
                            // Allow only numeric values and limit to 12 digits
                            const filteredValue = e.target.value
                              .replace(/[^0-9]/g, '')
                              .slice(0, 12);
                            handleNewCategoryChange({
                              target: {
                                name: 'CompAddharNo',
                                value: filteredValue,
                              },
                            });
                          }}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef13}
                          onKeyDown={(e) => handleKeyPress(e, inputRef14)}
                        />

                        {/* <label>Company Logo</label>
                        <input
                          name="CompLogo"
                          value={newCategory.CompLogo}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef14}
                          onKeyDown={(e) => handleKeyPress(e, inputRef15)}
                        /> */}

                        <label>Website</label>
                        <input
                          name="CompWebsite"
                          value={newCategory.CompWebsite}
                          onChange={handleNewCategoryChange}
                          type="url"
                          style={{ border: '1px solid #ddd', width: '100%' }}
                          ref={inputRef14}
                          onKeyDown={(e) => handleKeyPress(e, inputRef15)}
                        />

                        <label>VAT No</label>
                        <input
                          name="CompVATNo"
                          value={newCategory.CompVATNo}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef15}
                          onKeyDown={(e) => handleKeyPress(e, inputRef16)}
                        />

                        {/* <label>CGST No</label>
                        <input
                          name="CompCGSTNo"
                          value={newCategory.CompCGSTNo}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef17}
                          onKeyDown={(e) => handleKeyPress(e, inputRef18)}
                        /> */}

                        <label>CGST No</label>
                        <input
                          name="CompCGSTNo"
                          value={newCategory.CompCGSTNo}
                          onChange={(e) => {
                            // Allow only alphabets and numbers, and auto-capitalize alphabets
                            const filteredValue = e.target.value
                              .toUpperCase()
                              .replace(/[^A-Z0-9]/g, ''); // Convert to uppercase and remove invalid characters
                            handleNewCategoryChange({
                              target: {
                                name: 'CompCGSTNo',
                                value: filteredValue,
                              },
                            });
                          }}
                          type="text" // Input type as text to allow alphabets
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef16}
                          onKeyDown={(e) => handleKeyPress(e, inputRef17)}
                        />

                        <label>Status</label>
                        <input
                          name="CompStatus"
                          value={newCategory.CompStatus}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef17}
                          onKeyDown={(e) => handleKeyPress(e, inputRef18)}
                        />

                        <label>
                          Town <sup>*</sup>
                        </label>
                        <input
                          name="Town"
                          value={newCategory.Town}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef18}
                          onKeyDown={(e) => handleKeyPress(e, inputRef19)}
                        />
                        {/*added dropdown and its functionality for Country and states also   by Dnyaneshwar on 29Jan2025*/}
                        <label>
                          Country <sup>*</sup>
                        </label>
                        <select
                          name="Country"
                          value={newCategory.Country}
                          className={style.AddCustomerSelect}
                          style={{ border: '1px solid #ccc' }}
                          onChange={handleNewCategoryChange}
                          required="required"
                          ref={inputRef23}
                          onKeyDown={(e) => handleKeyPress(e, inputRef24)}
                        >
                          {allCountriesList.map((x, y) => (
                            <option key={y} value={x}>
                              {x}
                            </option>
                          ))}
                        </select>
                        <label>
                          State <sup> *</sup>
                        </label>
                        <select
                          name="CurrAddState"
                          value={newCategory.CurrAddState}
                          onChange={handleNewCategoryChange}
                          style={{ border: '1px solid #ccc' }}
                          className={style.AddCustomerInput}
                          ref={inputRef25}
                          onKeyDown={(e) => handleKeyPress(e, inputRef26)}
                          required
                        >
                          <option value="">Select a state</option>
                          {countryStates.map((x, index) => (
                            <option key={index} value={x}>
                              {x}
                            </option>
                          ))}
                        </select>

                        <label>
                          City <sup>*</sup>
                        </label>
                        <input
                          name="City"
                          value={newCategory.City}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef21}
                          onKeyDown={(e) => handleKeyPress(e, inputRef22)}
                        />

                        {/* <label>
                          Financial Year <sup>*</sup>
                        </label>
                        <input
                          name="FinancialYear"
                          value={newCategory.FinancialYear}
                          onChange={handleNewCategoryChange}
                          type="number"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef23}
                          onKeyDown={(e) => handleKeyPress(e, inputRef24)}
                        /> */}

                        <label>
                          Financial Year <sup>*</sup>
                        </label>
                        <input
                          name="FinancialYear"
                          value={newCategory.FinancialYear}
                          onChange={(e) => {
                            // Allow only the format YYYY-YY or YYYY-YYYY with strictly numbers and a hyphen
                            const filteredValue = e.target.value.replace(
                              /[^0-9\-]/g,
                              ''
                            ); // Remove non-numeric and non-hyphen characters
                            const match = filteredValue.match(
                              /^(\d{0,4})(-?)(\d{0,4})$/
                            );
                            if (match) {
                              const year1 = match[1]; // First 4 digits (YYYY)
                              const separator = match[2]; // Optional hyphen
                              const year2 = match[3].slice(
                                0,
                                year1.length === 4 ? 4 : 0
                              ); // Restrict year2 after a valid year1
                              e.target.value = year1 + separator + year2;
                            } else {
                              e.target.value = '';
                            }
                            handleNewCategoryChange({
                              target: {
                                name: 'FinancialYear',
                                value: e.target.value,
                              },
                            });
                          }}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef22}
                          onKeyDown={(e) => handleKeyPress(e, inputRef23)}
                        />

                        <label>
                          Base Currency <sup>*</sup>
                        </label>
                        <input
                          name="BaseCurrency"
                          value={newCategory.BaseCurrency}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef23}
                          onKeyDown={(e) => handleKeyPress(e, inputRef24)}
                        />

                        <label>Transaction Series</label>
                        <input
                          name="TransactionSeries"
                          value={newCategory.TransactionSeries}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: '1px solid #ddd' }}
                          ref={inputRef24}
                          onKeyDown={(e) => handleKeyPress(e, inputRef25)}
                        />

                        {/*added dropdown for login Status by Dnyaneshwar */}

                        <label>Login Status</label>
                        <select
                          required
                          name="CompLoginStatus"
                          value={newCategory.CompLoginStatus}
                          onChange={handleNewCategoryChange}
                          style={{ border: '1px solid #ddd' }}
                        >
                          <option value="">Select</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                        {/* <label>Login Status</label>
                        <input
                          name="CompLoginStatus"
                          value={newCategory.CompLoginStatus}
                          onChange={handleNewCategoryChange}
                          type="text"
                          style={{ border: "1px solid #ddd" }}
                          ref={inputRef25}
                          onKeyDown={(e) => handleKeyPress(e, null)}
                        /> */}
                      </div>
                    </Box>
                  </div>
                  {!loading ? (
                    <div className={style['btn-container']}>
                      <button className={style.buttons} type="submit">
                        <Icon icon="ic:baseline-check" width="24" height="24" />{' '}
                        Submit
                      </button>
                      <button
                        className={style.buttons}
                        style={{
                          backgroundColor: '#fff',
                          color: '#0077d4',
                          border: '1px solid #0077d4',
                        }}
                        type="button"
                        onClick={handleResetField}
                      >
                        <Icon
                          style={{ color: '#0077d4' }}
                          icon="ix:reset"
                          width="24"
                          height="24"
                        />
                        Reset
                      </button>
                      <button
                        className={style.buttons}
                        type="button"
                        onClick={handleList}
                      >
                        <Icon
                          icon="fluent:list-rtl-16-filled"
                          width="24"
                          height="24"
                        />
                        List
                      </button>
                    </div>
                  ) : null}
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
